var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShoppingCart = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-168 -462)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(168 462)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,484a2,2,0,1,1,2-2A2,2,0,0,1,185,484Zm-10-.01a1.99,1.99,0,1,1,2-1.99A2,2,0,0,1,175,483.99ZM187,479H175a1.977,1.977,0,0,1-1.714-.976,2,2,0,0,1-.035-1.994l1.35-2.44L171,466h-2v-2h3.27l.94,2h14.8a1,1,0,0,1,.87,1.48l-3.58,6.49A1.993,1.993,0,0,1,183.55,475H176.1l-1.1,2h12v2Zm-12.84-11h0l2.37,5h7.02l2.76-5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShoppingCart, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shopping_cart.996c9ccb.svg";
export { ForwardRef as ReactComponent };